/** Match the configured admin API by parsed origin and path, not string prefix. */
export function isAdminApiRequest(requestUrl: string, apiUrl: string, baseUrl: string): boolean {
  try {
    const target = new URL(requestUrl, baseUrl);
    const api = new URL(apiUrl, baseUrl);
    if (!['http:', 'https:'].includes(api.protocol) || target.origin !== api.origin) return false;
    if (target.username || target.password || api.username || api.password) return false;
    const prefix = api.pathname.replace(/\/+$/, '');
    if (!prefix) return false;
    return target.pathname === prefix || target.pathname.startsWith(prefix + '/');
  } catch {
    return false;
  }
}
